export { watchConfirmarCadastroPorToken } from './confirmarCadastroPorToken';
export { watchBuscarPendenteAprovacao } from './buscarPendenteAprovacao';
export { watchAprovarCadastro } from './aprovarCadastro';
export { watchAlterarSenha } from './alterarSenha';
export { watchReprovarCadastro } from './reprovarCadastro';



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/sagas.js